import { t } from "@lingui/core/macro";
import { captureException } from "@sentry/react";
import { useEffect } from "react";

import ErrorPage from "@/shared/components/ErrorPage";

export default function GenericErrorPage({ error }: { error: unknown }) {
  useEffect(() => {
    // log the error to sentry
    captureException(error);
  }, [error]);

  return (
    <ErrorPage
      title={t`Something Went Wrong`}
      message={t`Please refresh your page to continue your session. If your problem persists, please report the issue by clicking the "Report Issue" button below.`}
    />
  );
}
